import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "leading-17 mb-3" }
const _hoisted_2 = { class: "grid grid-cols-1 grid-rows-3 md:grid-cols-3 md:grid-rows-2 gap-6" }
const _hoisted_3 = { class: "grid sm:grid-cols-1 md:grid-cols-3 gap-6 mt-10" }
const _hoisted_4 = { class: "flex justify-start items-start my-4" }
const _hoisted_5 = ["src"]
const _hoisted_6 = { class: "flex flex-col justify-startitems-stretch my-auto" }
const _hoisted_7 = { class: "text-sm" }
const _hoisted_8 = { class: "text-sm text-dark-3 mt-2" }
const _hoisted_9 = { class: "text-sm font-bold" }
const _hoisted_10 = { class: "text-sm text-dark-3" }
const _hoisted_11 = {
  key: 1,
  class: "flex flex-col justify-start items-stretch bg-white rounded-xl p-5 shadow-lg hover:shadow-xl border border-white hover:border-light-3 h-full"
}
const _hoisted_12 = { class: "font-medium" }
const _hoisted_13 = { class: "my-4 text-sm" }
const _hoisted_14 = { class: "flex justify-start items-center mt-4" }
const _hoisted_15 = { class: "text-sm" }
const _hoisted_16 = { class: "text-sm text-dark-3 mt-4 mb-4" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_18 = { class: "text-sm font-bold" }
const _hoisted_19 = { class: "text-sm text-dark-3" }
const _hoisted_20 = {
  key: 1,
  class: "flex flex-col justify-start items-stretch bg-white rounded-xl p-5 shadow-lg hover:shadow-xl border border-white hover:border-light-3 h-full"
}
const _hoisted_21 = { class: "font-medium" }
const _hoisted_22 = { class: "my-4 text-sm" }
const _hoisted_23 = { class: "my-4 inline-block text-sm" }
const _hoisted_24 = { class: "flex flex-col justify-start items-stretch my-4" }
const _hoisted_25 = { class: "inline-flex justify-start items-center mb-2" }
const _hoisted_26 = { class: "text-sm" }
const _hoisted_27 = { class: "inline-flex justify-start items-center mb-2" }
const _hoisted_28 = { class: "text-sm" }
const _hoisted_29 = { class: "inline-flex justify-start items-center" }
const _hoisted_30 = { class: "text-sm" }
const _hoisted_31 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6" }
const _hoisted_32 = { class: "grid grid-cols-1 md:grid-cols-3 gap-6 mt-6" }
const _hoisted_33 = { class: "flex items-center justify-center mt-6" }
const _hoisted_34 = { class: "grid grid-cols-1 md:grid-cols-3 gap-7" }
const _hoisted_35 = { class: "flex items-center justify-center mt-6" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_dropdown_menu_item = _resolveComponent("dropdown-menu-item")!
  const _component_dropdown_menu = _resolveComponent("dropdown-menu")!
  const _component_card_chart = _resolveComponent("card-chart")!
  const _component_app_icon = _resolveComponent("app-icon")!
  const _component_card_kpi = _resolveComponent("card-kpi")!
  const _component_card_group = _resolveComponent("card-group")!
  const _component_app_section = _resolveComponent("app-section")!
  const _component_card_action = _resolveComponent("card-action")!
  const _component_automations_list = _resolveComponent("automations-list")!
  const _component_app_button = _resolveComponent("app-button")!
  const _component_mails_list_item = _resolveComponent("mails-list-item")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_app_section, { class: "pt-5 pb-8 bg-light-2" }, {
      default: _withCtx(() => [
        _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("pages.dashboard.header")), 1),
        _createVNode(_component_card_group, {
          title: _ctx.$t('general.performance')
        }, {
          sorting: _withCtx(() => [
            _createVNode(_component_dropdown_menu, {
              label: 
                        `${_ctx.$t('general.last')} ${_ctx.kpiDays} ${_ctx.$t('general.days')}`
                    
            }, {
              default: _withCtx(() => [
                _createVNode(_component_dropdown_menu_item, {
                  label: `${_ctx.$t('general.last')} 7 ${_ctx.$t('general.days')}`,
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.kpiDays = 7))
                }, null, 8, ["label"]),
                _createVNode(_component_dropdown_menu_item, {
                  label: 
                            `${_ctx.$t('general.last')} 30 ${_ctx.$t('general.days')}`
                        ,
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.kpiDays = 30))
                }, null, 8, ["label"]),
                _createVNode(_component_dropdown_menu_item, {
                  label: 
                            `${_ctx.$t('general.last')} 60 ${_ctx.$t('general.days')}`
                        ,
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.kpiDays = 60))
                }, null, 8, ["label"]),
                _createVNode(_component_dropdown_menu_item, {
                  label: 
                            `${_ctx.$t('general.last')} 90 ${_ctx.$t('general.days')}`
                        ,
                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.kpiDays = 90))
                }, null, 8, ["label"])
              ]),
              _: 1
            }, 8, ["label"])
          ]),
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_2, [
              _createVNode(_component_card_chart, {
                header: _ctx.$t('pages.dashboard.netSales'),
                datasets: _ctx.chart1Dataset,
                class: "md:block row-span-2 md:col-span-2",
                loading: _ctx.revenueChartsLoading
              }, null, 8, ["header", "datasets", "loading"]),
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.dashboard.totalDrivenRevenue'),
                currency: _ctx.currency,
                value: 
                        parseFloat(_ctx.kpis.maatoo_revenue_total.value.toFixed(1))
                    ,
                trend: _ctx.kpis.maatoo_revenue_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                ]),
                _: 1
              }, 8, ["header", "currency", "value", "trend", "loading"]),
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.dashboard.numberOfConversions'),
                value: parseFloat(_ctx.kpis.conversion_total.value.toFixed(1)),
                trend: _ctx.kpis.conversion_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "Conversion" })
                ]),
                _: 1
              }, 8, ["header", "value", "trend", "loading"])
            ])
          ]),
          _: 1
        }, 8, ["title"])
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, null, {
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_3, [
          (_ctx.store_connected)
            ? (_openBlock(), _createBlock(_component_card_group, {
                key: 0,
                title: _ctx.$t('pages.dashboard.keyPerformance'),
                class: "flex flex-col"
              }, {
                default: _withCtx(() => [
                  (_ctx.bestSellingProduct)
                    ? (_openBlock(), _createBlock(_component_card_action, {
                        key: 0,
                        header: _ctx.$t('pages.dashboard.bestSelling'),
                        "button-name": _ctx.$t('pages.dashboard.upsell'),
                        "action-disabled": true,
                        class: "flex-1"
                      }, {
                        revenue: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_9, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatNumber(_ctx.bestSellingProductRevenue)) + " " + _toDisplayString(_ctx.$t("pages.dashboard.netRevenue")), 1),
                            _createElementVNode("div", _hoisted_10, _toDisplayString(_ctx.bestSellingProductOrderQuantity) + " " + _toDisplayString(_ctx.$t("pages.dashboard.itemsSold")) + " " + _toDisplayString(_ctx.bestSellingProductOrderCount) + " " + _toDisplayString(_ctx.$t("pages.dashboard.orders")), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                              src: 
                                _ctx.bestSellingProduct.imageUrl ??
                                    '/assets/img/placeholder.svg'
                            ,
                              alt: "68x68",
                              class: "w-17 h17 rounded-md mr-5",
                              onError: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.productFallbackImage && _ctx.productFallbackImage(...args)))
                            }, null, 40, _hoisted_5),
                            _createElementVNode("div", _hoisted_6, [
                              _createElementVNode("span", _hoisted_7, _toDisplayString(_ctx.bestSellingProduct.title), 1),
                              _createElementVNode("span", _hoisted_8, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.bestSellingProduct.price.toFixed(2)), 1)
                            ])
                          ])
                        ]),
                        _: 1
                      }, 8, ["header", "button-name"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_11, [
                        _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.$t("pages.dashboard.bestSelling")), 1),
                        _createElementVNode("span", _hoisted_13, _toDisplayString(_ctx.$t("pages.dashboard.bestSellingMissing")), 1)
                      ]))
                ]),
                _: 1
              }, 8, ["title"]))
            : _createCommentVNode("", true),
          (_ctx.store_connected)
            ? (_openBlock(), _createBlock(_component_card_group, {
                key: 1,
                class: "flex flex-col"
              }, {
                default: _withCtx(() => [
                  (_ctx.highestValueSegment)
                    ? (_openBlock(), _createBlock(_component_card_action, {
                        key: 0,
                        header: _ctx.$t('pages.dashboard.topSegment'),
                        "button-name": _ctx.$t('pages.dashboard.rewardSegment'),
                        "action-disabled": true,
                        class: "flex-1"
                      }, {
                        revenue: _withCtx(() => [
                          _createElementVNode("div", null, [
                            _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatNumber(
                                        _ctx.highestValueSegment.total_order_value
                                    )) + " " + _toDisplayString(_ctx.$t("pages.dashboard.netRevenue")), 1),
                            _createElementVNode("div", _hoisted_19, _toDisplayString(_ctx.formatNumber(
                                        _ctx.highestValueSegment.total_order_count
                                    )) + " " + _toDisplayString(_ctx.$t("pages.dashboard.orders")), 1)
                          ])
                        ]),
                        default: _withCtx(() => [
                          _createElementVNode("div", _hoisted_14, [
                            _createVNode(_component_app_icon, {
                              name: "Users",
                              class: "mr-2"
                            }),
                            _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.highestValueSegment.name), 1)
                          ]),
                          _createElementVNode("div", _hoisted_16, [
                            _createTextVNode(_toDisplayString(_ctx.$t("pages.dashboard.averageOrderValue")) + ": " + _toDisplayString(_ctx.currency) + " " + _toDisplayString(_ctx.formatNumber(_ctx.highestValueSegment.avg_order_value, 2)), 1),
                            _hoisted_17,
                            _createTextVNode(" " + _toDisplayString(_ctx.highestValueSegment.lead_count) + " " + _toDisplayString(_ctx.$t("pages.dashboard.customers")) + " " + _toDisplayString(_ctx.$t("pages.dashboard.generate")) + " " + _toDisplayString((
                                (parseFloat(
                                    _ctx.highestValueSegment.total_order_value
                                ) *
                                    100) /
                                parseFloat(_ctx.highestValueSegment.total_revenue)
                            ).toFixed(0)) + "% " + _toDisplayString(_ctx.$t("pages.dashboard.revenue")), 1)
                          ])
                        ]),
                        _: 1
                      }, 8, ["header", "button-name"]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_20, [
                        _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.$t("pages.dashboard.topSegment")), 1),
                        _createElementVNode("span", _hoisted_22, _toDisplayString(_ctx.$t("pages.dashboard.topSegmentMissing")), 1)
                      ]))
                ]),
                _: 1
              }))
            : (_openBlock(), _createBlock(_component_card_group, {
                key: 2,
                title: _ctx.$t('pages.dashboard.keyPerformance'),
                class: "flex flex-col h-full col-span-2"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_card_action, {
                    "button-name": _ctx.$t('pages.dashboard.contactSupport'),
                    header: _ctx.$t('pages.dashboard.keyPerfDataMissingTitle'),
                    class: "h-full",
                    onClick: _ctx.goToSupportPage
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_23, _toDisplayString(_ctx.$t("pages.dashboard.keyPerfDataMissing")), 1)
                    ]),
                    _: 1
                  }, 8, ["button-name", "header", "onClick"])
                ]),
                _: 1
              }, 8, ["title"])),
          _createVNode(_component_card_group, {
            title: _ctx.$t('pages.dashboard.recommendations'),
            class: "flex flex-col"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_card_action, {
                header: _ctx.$t('pages.dashboard.optimizeShop'),
                "button-name": _ctx.$t('pages.dashboard.editSettings'),
                class: "flex-1",
                onClick: _ctx.openSettings
              }, {
                default: _withCtx(() => [
                  _createElementVNode("div", _hoisted_24, [
                    _createElementVNode("div", _hoisted_25, [
                      (_ctx.store_connected)
                        ? (_openBlock(), _createBlock(_component_app_icon, {
                            key: 0,
                            name: "CheckCircle",
                            class: "text-green-400 mr-2"
                          }))
                        : (_openBlock(), _createBlock(_component_app_icon, {
                            key: 1,
                            name: "ExclamationCircle",
                            class: "text-red-600 mr-2"
                          })),
                      _createElementVNode("span", _hoisted_26, _toDisplayString(_ctx.$t("pages.dashboard.connectStore")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_27, [
                      (_ctx.brand_customized)
                        ? (_openBlock(), _createBlock(_component_app_icon, {
                            key: 0,
                            name: "CheckCircle",
                            class: "text-green-400 mr-2"
                          }))
                        : (_openBlock(), _createBlock(_component_app_icon, {
                            key: 1,
                            name: "ExclamationCircle",
                            class: "text-red-600 mr-2"
                          })),
                      _createElementVNode("span", _hoisted_28, _toDisplayString(_ctx.$t("pages.dashboard.customizeBrand")), 1)
                    ]),
                    _createElementVNode("div", _hoisted_29, [
                      (_ctx.legal_updated)
                        ? (_openBlock(), _createBlock(_component_app_icon, {
                            key: 0,
                            name: "CheckCircle",
                            class: "text-green-400 mr-2"
                          }))
                        : (_openBlock(), _createBlock(_component_app_icon, {
                            key: 1,
                            name: "ExclamationCircle",
                            class: "text-red-600 mr-2"
                          })),
                      _createElementVNode("span", _hoisted_30, _toDisplayString(_ctx.$t("pages.dashboard.editLegalSettings")), 1)
                    ])
                  ])
                ]),
                _: 1
              }, 8, ["header", "button-name", "onClick"])
            ]),
            _: 1
          }, 8, ["title"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, null, {
      default: _withCtx(() => [
        _createVNode(_component_card_group, {
          title: _ctx.$t('pages.dashboard.automations'),
          class: "mt-10"
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_31, [
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.mails.totalMailsSent'),
                value: 
                        parseFloat(
                            _ctx.kpis.automation_mail_sent_total.value.toFixed(1)
                        )
                    ,
                trend: _ctx.kpis.automation_mail_sent_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "MailOpen" })
                ]),
                _: 1
              }, 8, ["header", "value", "trend", "loading"]),
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.mails.numberOfConversions'),
                value: 
                        parseFloat(
                            _ctx.kpis.automation_conversion_total.value.toFixed(1)
                        )
                    ,
                trend: _ctx.kpis.automation_conversion_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "Conversion" })
                ]),
                _: 1
              }, 8, ["header", "value", "trend", "loading"]),
              _createVNode(_component_card_kpi, {
                header: _ctx.$t('pages.automations.totalRevenue'),
                currency: _ctx.currency,
                value: 
                        parseFloat(
                            _ctx.kpis.automation_revenue_total.value.toFixed(1)
                        )
                    ,
                trend: _ctx.kpis.automation_revenue_total.trend,
                loading: _ctx.kpisLoading
              }, {
                icon: _withCtx(() => [
                  _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                ]),
                _: 1
              }, 8, ["header", "currency", "value", "trend", "loading"])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _createVNode(_component_card_chart, {
                header: _ctx.$t('pages.dashboard.netAutomationSales'),
                datasets: _ctx.chart2Dataset,
                class: "md:col-span-2",
                loading: _ctx.revenueChartsLoading
              }, null, 8, ["header", "datasets", "loading"]),
              _createVNode(_component_automations_list)
            ])
          ]),
          _: 1
        }, 8, ["title"]),
        _createElementVNode("div", _hoisted_33, [
          _createVNode(_component_app_button, {
            "button-style": "white",
            class: "shadow-lg",
            onClick: _ctx.goToAutomations
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("pages.dashboard.goToAutomations")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, null, {
      default: _withCtx(() => [
        (_ctx.kpis)
          ? (_openBlock(), _createBlock(_component_card_group, {
              key: 0,
              title: _ctx.$t('pages.dashboard.mails')
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_34, [
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.totalMailsSent'),
                    value: parseFloat(_ctx.kpis.mail_sent_total.value.toFixed(1)),
                    trend: _ctx.kpis.mail_sent_total.trend,
                    loading: _ctx.kpisLoading
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "MailOpen" })
                    ]),
                    _: 1
                  }, 8, ["header", "value", "trend", "loading"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.numberOfConversions'),
                    value: 
                        parseFloat(_ctx.kpis.mail_conversion_total.value.toFixed(1))
                    ,
                    trend: _ctx.kpis.mail_conversion_total.trend,
                    loading: _ctx.kpisLoading
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "Conversion" })
                    ]),
                    _: 1
                  }, 8, ["header", "value", "trend", "loading"]),
                  _createVNode(_component_card_kpi, {
                    header: _ctx.$t('pages.mails.totalRevenue'),
                    currency: _ctx.currency,
                    value: 
                        parseFloat(_ctx.kpis.mail_revenue_total.value.toFixed(1))
                    ,
                    trend: _ctx.kpis.mail_revenue_total.trend,
                    loading: _ctx.kpisLoading
                  }, {
                    icon: _withCtx(() => [
                      _createVNode(_component_app_icon, { name: "CurrencyDollar" })
                    ]),
                    _: 1
                  }, 8, ["header", "currency", "value", "trend", "loading"])
                ])
              ]),
              _: 1
            }, 8, ["title"]))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }),
    _createVNode(_component_app_section, { class: "pb-24" }, {
      default: _withCtx(() => [
        _createVNode(_component_card_group, {
          title: _ctx.$t('pages.dashboard.activeMails'),
          class: "mt-10 hidden md:block"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scheduledMails, (mail) => {
              return (_openBlock(), _createBlock(_component_mails_list_item, {
                mail: mail,
                key: mail.id,
                class: "mb-5",
                action: "view"
              }, null, 8, ["mail"]))
            }), 128)),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activeMails, (mail) => {
              return (_openBlock(), _createBlock(_component_mails_list_item, {
                mail: mail,
                key: mail.id,
                class: "mb-5",
                action: "view"
              }, null, 8, ["mail"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["title"]),
        _createElementVNode("div", _hoisted_35, [
          _createVNode(_component_app_button, {
            "button-style": "white",
            class: "shadow-lg",
            onClick: _ctx.goToMails
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t("pages.dashboard.goToMails")), 1)
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ]),
      _: 1
    })
  ], 64))
}